<template>
  <div>
    <v-toolbar dark color="primary" app clipped-right>
      <img
        height="38px"
        alt="Logo da empresa"
        :src="
          dadosEmpresa && dadosEmpresa.logo
            ? `data:image/png;base64, ${dadosEmpresa.logo}`
            : require('@/assets/logoHeader.png')
        "
      />
      <v-toolbar-title class="headline">
        <span>{{ dadosEmpresa ? dadosEmpresa.nome : "AppQuiz" }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-side-icon
        v-if="isAuthenticated"
        @click="menuOpen = !menuOpen"
      ></v-toolbar-side-icon>
    </v-toolbar>
    <v-navigation-drawer
      v-model="menuOpen"
      v-if="isAuthenticated"
      right
      clipped
      app
    >
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>fa fa-ellipsis-v</v-icon>
        </v-btn>
      </template>
      <v-layout column justify-space-between fill-height>
        <v-flex>
          <v-list dense>
            <v-list-tile class="py-1">
              <v-layout row justify-space-between align-center>
                <template v-for="(item, i) in listaCores">
                  <v-icon
                    v-if="item.val != selectedColor"
                    :key="i"
                    :color="item.color"
                    @click="changeColor(item.val)"
                  >
                    fa fa-circle
                  </v-icon>
                  <v-icon v-else :key="i" :color="item.color">
                    fa fa-check
                  </v-icon>
                </template>
              </v-layout>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile
              v-for="item in listaMenu"
              class="py-1"
              active-class="primary--text"
              :key="item.title"
              :to="item.to"
            >
              <v-list-tile-action>
                <v-icon> {{ item.icon }} </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile :to="{ name: 'alterarSenha' }" class="py-1">
              <v-list-tile-action>
                <v-icon> fa fa-lock </v-icon>
              </v-list-tile-action>
              <v-list-tile-title> Alterar Senha </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="atualizar" class="py-1">
              <v-list-tile-action>
                <v-icon> fa fa-sync-alt </v-icon>
              </v-list-tile-action>
              <v-list-tile-title> Atualizar </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="logout" class="py-1">
              <v-list-tile-action>
                <v-icon> fa fa-sign-out-alt </v-icon>
              </v-list-tile-action>
              <v-list-tile-title> Sair </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      menuOpen: false,
      listaCores: [
        { color: "red", val: "red" },
        { color: "grey", val: "grey" },
        { color: "light-blue", val: "lightBlue" },
        { color: "teal", val: "teal" },
        { color: "green", val: "green" },
        { color: "orange", val: "orange" },
        { color: "indigo", val: "indigo" },
      ],
    };
  },
  computed: {
    ...mapGetters(["isAccessExpired", "isAdmin", "user", "dadosEmpresa"]),
    listaMenu() {
      return [
        { to: "/clientes", title: "Clientes", icon: "fa fa-male" },
        {
          to: "/pontosPesquisa",
          title: "Pontos de Pesquisa",
          icon: "fa fa-tablet-alt",
        },
        { to: "/empresa", title: "Empresa e Filiais", icon: "fas fa-city" },
        { to: "/usuarios", title: "Usuarios", icon: "fa fa-users" },
        { to: "/arquivadas", title: "Arquivadas", icon: "fa fa-archive" },
      ].filter((el) => {
        if (!this.user) return false;
        if (this.isAdmin) return true;
        return this.$router.options.routes.find((route) => {
          return (
            route.path.match(el.to) &&
            route.meta &&
            route.meta.requiresAuth &&
            route.meta.adminOnly !== true
          );
        });
      });
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    selectedColor() {
      return this.$store.getters.selectedColor;
    },
  },
  created() {
    if (this.user)
      axios
        .get(`/empresa/getLogomarcaById/${this.user.idempresa}`)
        .then((res) => {
          this.setHeaderEmpresa({
            nome: this.user.fantasia,
            logo: res.data.img,
          });
        });
  },
  methods: {
    ...mapActions(["setHeaderEmpresa"]),
    formatDate(date) {
      if (!date) return "";
      const [ano, mes, dia] = date.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    changeColor(color) {
      this.$store.dispatch("changeColor", {
        idempresa: this.user.idempresa,
        color,
      });
    },
    atualizar() {
      location.reload();
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>
